import {RestApiService} from '../../../rest-api.service';
import {ContactPersonCreateReq, ContactPersonDetailRes, ContactPersonUpdateReq} from '../../../../contracts/v0/crm';
import {ApiV0Crm} from '../api.v0.crm';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0CrmContactPerson {

    segment = '/contact';

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    search(searchModel?: SearchModel) {
        return this.rest.post<SearchModel, BaseCollectionModel<ContactPersonDetailRes>>(`${this.segment}/search`, ContactPersonDetailRes, searchModel)
    }

    company(id: number) {
        return this.rest.get<BaseCollectionModel<ContactPersonDetailRes>>(`${this.segment}/company/${id}`, ContactPersonDetailRes)
    }

    createContact(createReq: ContactPersonCreateReq) {
        return this.rest.post<ContactPersonCreateReq, ContactPersonDetailRes>(`${this.segment}/create`, ContactPersonDetailRes, createReq)
    }

    bulkCreate(createReq: ContactPersonCreateReq[]) {
        return this.rest.post<ContactPersonCreateReq[], BaseCollectionModel<ContactPersonDetailRes>>(`${this.segment}/bulk`, ContactPersonDetailRes, createReq)
    }

    patchContact(updateReq: ContactPersonUpdateReq) {
        return this.rest.patch<ContactPersonUpdateReq, ContactPersonDetailRes>(this.segment, ContactPersonDetailRes, updateReq)
    }

    bulkDelete(ids: number[]) {
        return this.rest.delete<void>(this.segment, {}, ids)
    }
}
